import { useAdditionalFieldsQuery } from '@ManagerPortal/containers/Schedule/Data/useAdditionalFieldsQuery';
import { SCHEDULE_VIEW_MODE_VALUES } from '@ManagerPortal/containers/Schedule/Main/const';

import { useBusinessDisplayOptions } from '../BusinessDisplayOptionsFilters';
import { useEmployeeDisplayOptions } from '../EmployeeDisplayOptionsFilters';
import { useScheduleViewModeFilters } from '../ScheduleViewModeFilters';
import { ADDITIONAL_FIELD_SORT_DISPLAY_OPTION } from './constants';
import { SortOptionArr } from './types';

export const useSortOptionsWithAdditionalField = (
  baseSortOptions: SortOptionArr,
) => {
  const { data: additionalSortingField } = useAdditionalFieldsQuery((data) =>
    data?.find((field) => field.useForSorting),
  );

  const additionalSortingFieldOption = {
    ...ADDITIONAL_FIELD_SORT_DISPLAY_OPTION,
    label:
      additionalSortingField?.title ??
      ADDITIONAL_FIELD_SORT_DISPLAY_OPTION.label,
  };
  return additionalSortingField
    ? [...baseSortOptions, additionalSortingFieldOption]
    : baseSortOptions;
};

export const useDisplayOptions = () => {
  const bdo = useBusinessDisplayOptions();
  const edo = useEmployeeDisplayOptions();

  const { scheduleViewMode } = useScheduleViewModeFilters();

  if (scheduleViewMode === SCHEDULE_VIEW_MODE_VALUES.BUSINESS) {
    return bdo;
  }

  return edo;
};
